import { Link } from 'react-router-dom';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import { Icon } from '../components/ui/Icon';

const VALUES = [
  {
    title: 'Science-Backed Peptides',
    body: 'Our formulas are built around GHK-CU — a copper peptide studied for its ability to rejuvenate, smooth, and restore skin\'s youthful vitality. Real actives, at levels that do something.',
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.8}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.955 11.955 0 01.75 12c0 6.627 5.373 12 12 12s12-5.373 12-12c0-2.717-.904-5.222-2.428-7.175" />
      </svg>
    ),
  },
  {
    title: 'Bee Venom Beauty',
    body: 'Natural, effective, and luxurious. Our bee venom solutions are formulated to stimulate collagen and promote a youthful, lit-from-within radiance.',
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.8}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 6a7.5 7.5 0 107.5 7.5h-7.5V6z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 10.5H21A7.5 7.5 0 0013.5 3v7.5z" />
      </svg>
    ),
  },
  {
    title: 'Clean & Ethically Sourced',
    body: 'Boho-luxe botanicals chosen for nature\'s healing properties and combined with modern formulation. Every product is clean, vegan, and never tested on animals.',
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.8}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582" />
      </svg>
    ),
  },
  {
    title: 'A Program That Rewards You',
    body: 'Love your results? Share them. Our three-tier referral program pays you back as redeemable referral cash — applied 1:1 at checkout against your order. Every reward is tracked in real time on your dashboard, with nothing hidden.',
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.8}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 3v11.25A2.25 2.25 0 006 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0118 16.5h-2.25m-7.5 0h7.5m-7.5 0l-1 3m8.5-3l1 3m0 0l.5 1.5m-.5-1.5h-9.5m0 0l-.5 1.5" />
      </svg>
    ),
  },
];

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Navbar />

      {/* Hero */}
      <section className="bg-tea-700 text-white py-20 md:py-28">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-tea-300 text-sm font-semibold uppercase tracking-widest mb-4">About AB8 Beauty</p>
          <h1 className="text-4xl md:text-6xl font-extrabold tracking-tight leading-tight max-w-2xl">
            Elevate your glow, naturally.
          </h1>
          <p className="mt-6 text-tea-200 text-lg md:text-xl max-w-2xl leading-relaxed">
            AB8 Beauty crafts advanced topical GHK-CU and bee venom beauty solutions for radiant,
            natural skin — a fusion of cutting-edge skincare actives and boho-luxe botanicals that
            nurture your skin and your spirit.
          </p>
        </div>
      </section>

      {/* Mission */}
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 leading-tight">
              Skincare that nurtures your skin and your spirit.
            </h2>
            <p className="mt-5 text-gray-600 text-lg leading-relaxed">
              AB8 Beauty blends science-backed actives — GHK-CU peptides and bee venom — with
              ethically sourced, boho-luxe botanicals. The result is a line of products that work
              as beautifully as they feel, celebrating nature's healing properties through modern
              formulation.
            </p>
            <p className="mt-4 text-gray-600 text-lg leading-relaxed">
              And when you fall in love with your results, our three-tier referral program pays you
              back as redeemable referral cash, applied 1:1 at checkout. Glow, share, and get
              rewarded.
            </p>
            <div className="mt-8 flex gap-4 flex-wrap">
              <Link to="/shop" className="btn-primary">Shop the Collection</Link>
              <Link to="/register" className="btn-secondary">Join the Referral Program</Link>
            </div>
          </div>
          <div className="bg-tea-50 rounded-2xl p-10 flex flex-col gap-5">
            {[
              { stat: '10+ yrs', label: 'Of skincare expertise' },
              { stat: '30+', label: 'Unique product formulas' },
              { stat: '5,000+', label: 'Happy clients worldwide' },
              { stat: 'Vegan', label: 'Clean & cruelty-free' },
            ].map(({ stat, label }) => (
              <div key={label} className="flex items-center gap-4">
                <span className="text-tea-700 font-extrabold text-2xl w-28 shrink-0">{stat}</span>
                <span className="text-gray-600">{label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-16 md:py-24 bg-gray-50">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">What we stand for</h2>
          <div className="grid sm:grid-cols-2 gap-8">
            {VALUES.map((v) => (
              <div key={v.title} className="bg-white rounded-xl p-8 shadow-sm border border-gray-100">
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-tea-100 text-tea-700">
                  {v.icon}
                </span>
                <h3 className="mt-5 font-bold text-gray-900 text-lg">{v.title}</h3>
                <p className="mt-2 text-gray-600 leading-relaxed">{v.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Skincare notice */}
      <section className="py-12 bg-amber-50 border-y border-amber-200">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-amber-900 text-sm leading-relaxed max-w-3xl mx-auto">
            <strong><Icon name="leaf" className="inline w-4 h-4 align-[-2px] mr-1 text-tea-600" />For external cosmetic use.</strong> AB8 Beauty products are topical skincare
            and cosmetics. These statements have not been evaluated by the FDA, and our products are
            not intended to diagnose, treat, cure, or prevent any disease. We recommend a patch test
            before first use; discontinue if irritation occurs.
          </p>
          <Link to="/compliance" className="mt-4 inline-block text-amber-800 underline text-sm hover:text-amber-900">
            Read our ingredient & safety info →
          </Link>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Ready to glow?</h2>
          <p className="text-gray-600 mb-8">Create your account, shop the collection, and start earning referral rewards.</p>
          <div className="flex justify-center gap-4 flex-wrap">
            <Link to="/register" className="btn-primary">Create Account</Link>
            <Link to="/support" className="btn-secondary">Contact Us</Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
